import React, { createContext, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isContactMainCharacter } from "../Utils/Utils"
import { getFileUrl } from '../minioConfig';

const StoryContext = createContext();

const StoryProvider = ({ children }) => {
    const { t } = useTranslation();
    const [id, setId] = useState('');
    const [music, setMusic] = useState(getFileUrl('musics/Summer Somewhere In Cuba - Cumbia Deli.mp3'));
    const [messagesList, setMessagesList] = useState([])
    const [variablesList, setVariablesList] = useState([])
    const [eventsList, setEventsList] = useState([])
    const [selectedContact, setSelectedContact] = useState("");
    const [creationDate, setCreationDate] = useState(null);
    const [contactList, setContactList] = useState([]);
    const [contexteHistoire, setContexteHistoire] = useState("");
    const [parameters, setParameters] = useState({
        name: t('NewStoryTitle'),
        language: 'francais',
        context: '',
        start_date: new Date(),
        access: 'limited',
        financial_status: 'tokenUser',
        default_model: 'Mistral-Medium',
        home_message: '',
        thumbnail: null,
        music: null,
        image_seed: null,
        ressources_complexes: [], // TODO Handle this one too
      });
    const [dynamicTime, setDynamicTime] = useState(null);
    const [homeGreetingMessage, setHomeGreetingMessage] = useState("");
    const [endStoryMessageIdDisplayed, setEndStoryMessageIdDisplayed] = useState("");
    const [promptSystemeChoisi, setPromptSystemeChoisi] = useState("");
    const [promptContinueChoisi, setPromptContinueChoisi] = useState("");
    const [promptInitialChoisi, setPromptInitialChoisi] = useState("");
    const [promptJudgeChoisi, setPromptJudgeChoisi] = useState("");
    const [ressourcesComplexes, setRessourcesComplexes] = useState([]);
    const mainCharacter = useMemo(() => contactList.find(contact => isContactMainCharacter(contact)) || {}, [contactList]); // TODO an optimisation can surely be made here
    const contactListWithoutMainCharacter = useMemo(() => contactList.filter(contact => !isContactMainCharacter(contact)) || [], [contactList]);
    const selectedContactRecord = useMemo(() => contactList.find(contact => contact.number === selectedContact), [selectedContact]);
    const selectedContactName = useMemo(() => selectedContactRecord?.name, [selectedContactRecord]); // TODO eventually get rid of it
    const [sessionId, setSessionId] = useState(null);

    const value = {
        id, setId,
        music, setMusic,
        messagesList, setMessagesList,
        variablesList, setVariablesList,
        eventsList, setEventsList,
        selectedContact, setSelectedContact,
        creationDate, setCreationDate,
        contactList, setContactList,
        contexteHistoire, setContexteHistoire,
        parameters, setParameters,
        dynamicTime, setDynamicTime,
        homeGreetingMessage, setHomeGreetingMessage,
        endStoryMessageIdDisplayed, setEndStoryMessageIdDisplayed,
        promptSystemeChoisi, setPromptSystemeChoisi,
        promptContinueChoisi, setPromptContinueChoisi,
        promptInitialChoisi, setPromptInitialChoisi,
        promptJudgeChoisi, setPromptJudgeChoisi,
        ressourcesComplexes, setRessourcesComplexes,
        mainCharacter, contactListWithoutMainCharacter,
        selectedContactRecord, selectedContactName,
        sessionId, setSessionId,
    }

    return (
        <StoryContext.Provider value={value}>
            {children}
        </StoryContext.Provider>
    );
}

export { StoryProvider, StoryContext };